<template>
    <div>
        <div class="column-layout">
            <div class="table-layout">
                <div class="search-layout">
                    <el-input v-model="title" style="width: 225px;" class="mr10 mb10">
                        <template slot="prepend">合同名称</template>
                    </el-input>
                    <el-button class="el-search-btn" type="primary" icon="el-icon-search" @click="handlePageChange(1)">搜索</el-button>
                </div>
                <el-table :data="contractList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : selectContract!= null && selectContract.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" label="合同名称"></el-table-column>
                    <el-table-column prop="fstPartyName" label="甲方名称"></el-table-column>
                    <el-table-column prop="fstPartyHtBh" label="甲方合同编号"></el-table-column>
                    <el-table-column prop="sndPartyName" label="乙方名称"></el-table-column>
                    <el-table-column prop="sndPartyHtBh" label="乙方合同编号"></el-table-column>
                    <el-table-column prop="signDate" label="签署日期"></el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import contractApi from '../../api/contract'

    export default {
        name: 'swb-contract-list-for-select',
        desc: '合同-选择',
        props: {
            contractTypeList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            existTradeVoucherFlag: {
                type: Boolean,
                default: false,
            },
            contractType: {
                type: Number,
            },
            params: {
                type: Object,
                default: null,
            }
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                contractList: [],
                selectContract: {},
                title: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.getContractList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getContractList();
            },
            getContractList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let filterItems = self.params || {};
                if(!Utils.isNoB(self.title)) {
                    filterItems.title = self.title;
                }
                if(!Utils.isNoB(self.contractType)) {
                    filterItems.typeId = self.contractType;
                }
                if(!Utils.isNoB(self.contractTypeList) && self.contractTypeList.length > 0) {
                    filterItems.contractTypeList = self.contractTypeList;
                }
                if(Utils.isNoB(self.params)) {
                    filterItems.existTradeVoucherFlag = self.existTradeVoucherFlag;
                    filterItems.curValid = true;
                    filterItems.closed = false;
                    filterItems.lockMode = 0;
                    filterItems.offline = false;
                }
                postData.filterItems = filterItems;
                contractApi.getContractList(postData, function (result) {
                    if(result.type === "info") {
                        let data = result.data;
                        self.contractList = data.rows;
                        //
                        let pagination = data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleCurrentChange: function (val) {
                this.selectContract = Utils.merge({}, val);
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                if(self.selectContract != null && self.selectContract.id != null) {
                    result.type = "info";
                    result.data = self.selectContract;
                } else {
                    result.type = "warn";
                    result.message = "请选择需要的合同！";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractListForSelect.vue